import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { LatestNews } from '../../components';
// import { HomeBinanceNFTBanner } from '../../components/HomeBinanceNFTBanner/HomeBinanceNFTBanner';
import { TowerPlatform } from '../../components/TowerPlatform';
import { TowerTokenIntro } from '../../components/TowerTokenIntro';
import { TowerUtility } from '../../components/TowerUtility/TowerUtility';
import { WhereToGetTower } from '../../components/WhereToGetTower';
import { NewsLetterComponent } from '../../components/Newsletter/NewsletterComponent';
import styles from './Home.module.scss';
// import { HomePageTowerSaleLive } from '../../components/HomePageTowerSaleLive/HomePageTowerSaleLive';
import { HomePageCarousel } from '../../components/HomePageCarousel';

const Home = () => {
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        if (location.state) {
            if (location.state.news) {
                scrollToId('#latest_news', 460);
            } else if (location.state.chest_sale) {
                scrollToId('#chest_sale', 275);
            } else if (location.state.tower_token_intro) {
                scrollToId('#tower_token_intro', 460);
            } else if (location.state.platform) {
                scrollToId('#platform', 540);
            } else if (location.state.utility) {
                scrollToId('#utility', 460);
            } else if (location.state.view) {
                scrollToId('#view');
            } else if (location.state.get_tower) {
                scrollToId('#getTower', 640);
            } else if (location.state.available_on) {
                scrollToId('#available_on', 540);
            }

            history.replace({ state: null });
        }
    });

    const scrollToId = (id, mobile_offset) => {
        const element = document.querySelector(id);
        if (element) {
            const topPos = element.getBoundingClientRect().top + window.pageYOffset;

            let offset = 50;
            let connectedOffset =
                location.state.connected == true
                    ? mobile_offset + 50
                    : mobile_offset;
            let showOffset = window.innerWidth < 1000 ? connectedOffset : 0;
            const menu = document.getElementById('navbar-menu');
            if (menu.classList.contains('show')) {
                offset = offset + showOffset;
            }

            window.scroll({
                top: topPos - offset,
                left: 0,
                behavior: 'smooth',
            });
        }
    };

    return (
        <>
            {/* <HomeBinanceNFTBanner /> */}
            {/* <HomePageTowerSaleLive /> */}
            <HomePageCarousel />
            <TowerTokenIntro />
            <TowerPlatform />
            <TowerUtility />
            <WhereToGetTower />
            <LatestNews />
            <div className={styles.newsletter}>
                <NewsLetterComponent />
            </div>
        </>
    );
};

export { Home };
